import { createFileRoute } from "@tanstack/react-router";
import { MobileScreen } from "../components/settings/mobile-screen.tsx";
import { SettingsLoading } from "../components/settings/shell.tsx";
import { useSettingsFranchise } from "../components/settings/use-settings-franchise.ts";

export const Route = createFileRoute("/installningar/mobil")({ component: Screen });

function Screen() {
  const franchise = useSettingsFranchise();
  if (franchise === null) return <SettingsLoading />;
  return <MobileScreen franchiseId={franchise.id} />;
}
